import clsx from 'clsx';
import React from 'react';
import styles from './SectionHeader.module.scss';
export const SectionHeader = ({ title, variant = 'border-bottom', extraContent = null, }) => {
    return (<div className={clsx(styles.sectionHeader, styles[variant])}>
      <h2 className='owners-heading-2'>{title}</h2>
      {extraContent && <div className={styles.extraContent}>{extraContent}</div>}
    </div>);
};
